<template>
  <v-container id="get-pmd">
    <city-header :payload="payload"> </city-header>
    <v-row>
      <textarea id="texto_relatorio" cols="60" rows="15" hidden="false">
        Agora que você respondeu ao diagnóstico ainda existem alguns desafios a serem percorridos.
        Observe o plano de ação e não desanime!
        Vamos tornar o seu {{
          isGov ? "projeto" : "município"
        }} um bom lugar para empreender?
      </textarea>

      <v-col class="text-right">
        <v-btn
          v-if="
            isAdmin ||
            isConsultorCondutorMunicipio ||
            isConsultorEspecialistaMunicipio
          "
          outlined
          color="primary"
          class="ml-3"
          @click="update()"
        >
          <span>Atualizar</span>
        </v-btn>

        <v-btn
          v-if="
            isAdmin ||
            isConsultorCondutorMunicipio ||
            isConsultorEspecialistaMunicipio ||
            isAnalista
          "
          outlined
          color="primary"
          class="ml-3"
          @click="createPDF"
        >
          <span>Download PDF</span>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="payload.perguntas"
          class="elevation-1"
          hide-default-footer
          disable-pagination
          disable-sort
          ref="pmdTable"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <template v-for="(item, index) in items">
                <!-- Linha de título quando o nome do acompanhamento mudar -->
                <tr
                  v-if="
                    index === 0 ||
                    item.acompanhamento.nome !==
                      items[index - 1].acompanhamento.nome
                  "
                >
                  <td
                    :colspan="headers.length"
                    class="font-weight-bold grey lighten-4"
                  >
                    {{ item.acompanhamento.nome }} -
                    {{ item.acompanhamento.criacao | moment("DD/MM/YYYY") }}
                  </td>
                </tr>

                <tr>
                  <td>
                    {{ item.pergunta.numero }}
                  </td>
                  <!-- Nome com link -->
                  <td>
                    <a
                      :href="`./#/cidade/${item.municipioId}/acompanhamento/obter/${item.acompanhamentoId}`"
                    >
                      {{ item.acompanhamento.nome }}
                    </a>
                  </td>

                  <!-- Ações (texto ou ação) -->
                  <td>
                    {{
                      item.pergunta.acao !== null &&
                      item.pergunta.acao !== undefined
                        ? item.pergunta.acao
                        : item.pergunta.texto
                    }}
                  </td>

                  <!-- Pontos -->
                  <td>
                    {{ item.pergunta.pontos }}
                  </td>

                  <!-- Prazo e Indicador -->
                  <td>
                    <v-text-field
                      label="Prazo"
                      name="prazo"
                      v-mask="'##/##/####'"
                      type="text"
                      required
                      v-model="item.prazo"
                    ></v-text-field>

                    <v-text-field
                      label="Indicador"
                      name="indicador"
                      type="text"
                      required
                      v-model="item.indicador"
                      v-if="env === 'SC' || env === 'MS'"
                    ></v-text-field>
                  </td>

                  <!-- Responsável e Status -->
                  <td>
                    <v-text-field
                      label="Responsável"
                      name="responsavel"
                      type="text"
                      required
                      v-model="item.responsavel"
                    ></v-text-field>

                    <v-select
                      v-model="item.status"
                      item-text="text"
                      item-name="value"
                      item-value="value"
                      :items="status"
                      label="Status"
                      placeholder="Status"
                    ></v-select>
                  </td>

                  <!-- Meta e Observações -->
                  <td>
                    <v-text-field
                      label="Meta"
                      name="meta"
                      type="text"
                      required
                      v-model="item.meta"
                      v-if="env === 'SC' || env === 'MS'"
                    ></v-text-field>

                    <v-textarea
                      label="Observações"
                      name="observacoes"
                      required
                      v-model="item.observacoes"
                    ></v-textarea>
                  </td>

                  <!-- Evidência -->
                  <td>
                    <app-modal-show-evidence
                      :evidence="item.pergunta.evidencia"
                      :color="'primary'"
                      v-if="item.pergunta.evidencia"
                    >
                    </app-modal-show-evidence>
                  </td>
                </tr>
              </template>
            </tbody>
          </template>

          <template slot="no-data">
            <span>Nenhuma pergunta retornada</span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CityHeader from "@/modules/city/components/Header";
import { pmdAPI } from "../PMDAPI";
import { mapActions, mapGetters } from "vuex";
import JsPDF from "jspdf";
import "jspdf-autotable";
import { convertImgToBase64 } from "@/helpers/convertImgToBase64";

import AppModalShowEvidence from "@/modules/diagnostic/components//ModalShowEvidence";

export default {
  components: {
    CityHeader,
    AppModalShowEvidence,
  },
  data() {
    return {
      headers: [
        { text: "Nº", value: "pergunta.numero" },
        { text: "Tema", value: "pergunta.tema.nome" },
        { text: "Ação", value: "acoes", width: 300 },
        { text: "Pontos", value: "pergunta.pontos" },
        { text: "", value: "prazo" },
        { text: "", value: "responsavel" },
        { text: "", value: "meta" },
        { text: "Evidência", value: "pergunta.evidencia" },
      ],
      payload: {
        municipioId: this.$route.params.id,
        acompanhamentoId: this.$route.params.acompanhamento,
        perguntas: [],
      },
      status: [
        { text: "Não Iniciada", value: "Não Iniciada" },
        { text: "Em Andamento", value: "Em Andamento" },
        { text: "Atrasada", value: "Atrasada" },
      ],
      env: this.$store.state.uf,
      logo: this.$store.state.logo,
      config: JSON.parse(localStorage.getItem("config")),
      userTeste: JSON.parse(localStorage.getItem("user")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
    };
  },
  methods: {
    ...mapActions([
      "setLoading",
      "setConsultorCondutorMunicipio",
      "setConsultorEspecialistaMunicipio",
      "setAnalistaMunicipio",
      "setADMunicipio",
    ]),
    listPMD() {
      this.setLoading(true);

      pmdAPI
        .get(this.$route.params.acompanhamento.split(","))
        .then((resp) => {
          this.payload.perguntas = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter perguntas");
        });
    },
    update() {
      this.setLoading(true);

      const perguntas = this.payload.perguntas.map((pergunta) => {
        return {
          perguntaPMDId: pergunta.perguntaPMDId || 0,
          acompanhamentoId: pergunta.acompanhamentoId || 0,
          municipioId: pergunta.municipioId || 0,
          perguntaId: pergunta.perguntaId || 0,
          perguntaMunicipioId: pergunta.perguntaMunicipioId || 0,
          usuarioId: pergunta.usuarioId || 0,
          resposta: pergunta.resposta || false,
          prazo: pergunta.prazo || "",
          responsavel: pergunta.responsavel || "",
          meta: pergunta.meta || "",
          indicador: pergunta.indicador || "",
          observacoes: pergunta.observacoes || "",
          status: pergunta.status || "",
          uf: this.uf,
        };
      });

      pmdAPI
        .update(perguntas)
        .then((resp) => {
          this.setLoading(false);
          this.$notification.success("Plano de ação atualizado com sucesso");
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao atualizar Plano de ação");
        });
    },
    async createPDF() {
      var source = this.$refs["pmdTable"];
      let rows = [];
      let columnHeader = [];

      let pdfName =
        "Plano de Ação - " +
        this.payload.perguntas[0].municipio.nome +
        this.payload.perguntas[0].acompanhamento.nome;

      source.items.forEach((element) => {
        var temp = [];
        if (
          this.$store.state.uf !== "SC" &&
          this.$store.state.uf !== "MS" &&
          this.$store.state.uf !== "RJ"
        ) {
          temp = [
            element.pergunta.numero,
            element.pergunta.tema.nome,
            element.pergunta.texto,
            element.pergunta.pontos,
            element.prazo,
            element.responsavel,
            element.status,
          ];
        } else if (this.$store.state.uf === "RJ") {
          temp = [
            element.pergunta.numero,
            element.pergunta.tema.nome,
            element.pergunta.acao,
            element.pergunta.pontos,
            element.prazo,
            element.responsavel,
            element.status,
          ];
        } else {
          temp = [
            element.pergunta.numero,
            element.pergunta.tema.nome,
            element.pergunta.texto,
            element.pergunta.pontos,
            element.prazo,
            element.indicador,
            element.responsavel,
            element.status,
            element.meta,
            element.observacoes,
          ];
        }

        rows.push(temp);
      });

      var subTitulo = this.payload.perguntas[0].acompanhamento.nome;
      var dimensions = {
        width: 0,
        height: 50,
      };
      var titulo = "Plano de Ação";
      var logoCidade = new Image();

      if (this.isSala) {
        subTitulo =
          subTitulo == "Diagnóstico" ? "Acompanhamento Geral" : subTitulo;
        titulo = "Plano de Ação - Selo Sebrae de Referência em Atendimento";
        logoCidade.src = await convertImgToBase64(
          `https://slide1-images.s3.amazonaws.com/public/logo/logo-selo.png`,
          400,
          500
        );

        dimensions = {
          width: 70,
          height: 70,
        };
        if (this.$store.state.uf !== "SC" && this.$store.state.uf !== "MS") {
          columnHeader = [
            "Nº",
            "Pilar",
            "Ação",
            "Pontos",
            "Prazo",
            "Resp.",
            "Status",
          ];
        } else {
          columnHeader = [
            "Nº",
            "Pilar",
            "Ação",
            "Pontos",
            "Prazo",
            "Indicador",
            "Resp.",
            "Status",
            "Meta",
            "Observações",
          ];
        }
      } else {
        logoCidade.src = await convertImgToBase64(
          `https://slide1-images.s3.amazonaws.com/public/logo/${this.$store.state.logo}_color.png`
        );
        if (this.$store.state.uf !== "SC" && this.$store.state.uf !== "MS") {
          columnHeader = [
            "Nº",
            "Tema",
            "Ação",
            "Pontos",
            "Prazo",
            "Resp.",
            "Status",
          ];
        } else {
          columnHeader = [
            "Nº",
            "Tema",
            "Ação",
            "Pontos",
            "Prazo",
            "Indicador",
            "Resp.",
            "Status",
            "Meta",
            "Observações",
          ];
        }
      }

      var logoSebrae = new Image();
      logoSebrae.src = await convertImgToBase64(
        "https://slide1-images.s3.amazonaws.com/public/sebrae-logo.png"
      );

      var textoRelatorio = document.getElementById("texto_relatorio");

      var doc = new JsPDF("l", "pt");
      doc.setFontSize(16).setFont(undefined, "bold");
      doc.text(200, 45, titulo);

      doc.setFontSize(14).setFont(undefined, "normal");
      doc.text(200, 65, subTitulo);

      doc.setFontSize(13).setFont(undefined, "bold");
      doc.text(200, 85, this.payload.perguntas[0].municipio.nome);
      doc.addImage(logoSebrae, "PNG", 700, 30, 100, 50);
      if (
        this.isFullAdmin ||
        (this.groupsConfig.visualizarLogo && this.config.visualizarLogo)
      ) {
        doc.addImage(
          logoCidade,
          "PNG",
          40,
          30,
          dimensions.width,
          dimensions.height
        );
      }

      doc.setFontSize(11).setFont(undefined, "normal");
      if (this.$store.state.uf === "BA") {
        doc.text(50, 120, textoRelatorio.value);
      }
      doc.autoTable(columnHeader, rows, {
        startY: 170,
        styles: {
          overflow: "linebreak",
          cellWidth: "wrap",
          fontSize: 9,
          cellPadding: 3,
        },
        columnStyles: {
          0: { cellWidth: 25 }, // Nº
          1: { cellWidth: 80 }, // Tema/Pilar
          2: { cellWidth: 200 }, // Ação (texto mais longo)
          3: { cellWidth: 40 }, // Pontos
          4: { cellWidth: 60 }, // Prazo
          5: { cellWidth: 80 }, // Responsável
          6: { cellWidth: 60 }, // Status
          7: { cellWidth: 50 }, // Meta (SC/MS)
          8: { cellWidth: 100 }, // Observações (SC/MS)
          9: { cellWidth: 100 }, // Observações alternativo
        },
        margin: { left: 20, right: 20 },
        tableWidth: "auto",
      });
      doc.save(pdfName + ".pdf");
    },
  },
  mounted() {
    this.listPMD();
    this.setConsultorCondutorMunicipio(this.$route.params.id);
    this.setConsultorEspecialistaMunicipio(this.$route.params.id);
    this.setAnalistaMunicipio(this.$route.params.id);

    if (this.$store.state.uf === "SC" || this.$store.state.uf === "MS") {
      this.headers = [
        { text: "Nº", value: "pergunta.numero" },
        { text: "Tema", value: "pergunta.tema.nome" },
        { text: "Ação", value: "pergunta.texto", width: 300 },
        { text: "Pontos", value: "pergunta.pontos" },
        { text: "Medalha", value: "pergunta.selo" },
        { text: "", value: "prazo" },
        { text: "", value: "responsavel" },
        { text: "", value: "meta" },
        { text: "Evidência", value: "pergunta.evidencia" },
      ];
    }
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isAnalista",
      "isFullAdmin",
      "isSala",
      "isGov",
      "uf",
    ]),
  },
};
</script>
